import React from 'react';
import {DatePicker} from 'components';
import {moment, over} from 'helpers';
import css from './repetition.module.scss';

export function StartDate({ value, popup, setRepeatValues }) {
  return (
    <div className={css('start-date')}>
      <DatePicker
        dropdowns={false}
        monthsShown={1}
        maxDate={value.endDate}
        onChange={over(scheduleDate => setRepeatValues({ scheduleDate: scheduleDate ? scheduleDate.unix() : '' }), popup.close)}
        selected={moment.parse(value.scheduleDate)}
      />
    </div>
  );
}
